export const GET_PASSWORD_RESET_LINK = 'GET_PASSWORD_RESET_LINK';
export const getPasswordResetLink = (payload: { Email: string, Culture: string }) => ({ type: GET_PASSWORD_RESET_LINK, payload });

export const SET_PASSWORD_RESET_LINK = 'SET_PASSWORD_RESET_LINK';
export const setPasswordResetLink = (payload: number) => ({ type: SET_PASSWORD_RESET_LINK, payload });


